<template>
    <div>
        <my-search @search="searchHandler" v-model="pgData" title-placeholder="标段名称/标段编号">

            <el-form-item slot="time"></el-form-item>
            <template slot="btn">
                <el-button v-if="model.isxyf" type="success" icon="el-icon-search" @click="searchXyf()">信用分查询</el-button>
            </template>
        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="标段名称" prop="bdname" min-width="150" fixed="left"></el-table-column>
            <el-table-column label="标段编码" prop="bdcode" sortable min-width="110"></el-table-column>
            <el-table-column label="标段分类" prop="bdtypename" sortable width="170"></el-table-column>
            <el-table-column label="标段合同估算价(万元)" prop="bdhtgsj" sortable width="170"></el-table-column>
            <el-table-column label="清单状态" min-width="110">
                <template slot-scope="scope">
                    <my-tag type="success" v-if="scope.row.isqd==='1'">招标人清单100.00%</my-tag>
                    <my-tag 
                        type="success" 
                        v-if="scope.row.by3==='100.00'">
                        投标人清单100.00%
                    </my-tag>
                    <my-tag 
                        type="success" 
                        v-if="scope.row.bimimportstatus==='100.00'">
                        导入BIM100.00%
                    </my-tag>
                    <my-tag 
                        type="success" 
                        v-if="(scope.row.bimimportstatus==='100.00'&&scope.row.issxfbim==='1'&&scope.row.sxfbimimportstatus==='100')">
                        导入二信封BIM100.00%
                    </my-tag>
                    <el-row 
                        style="margin-top:5px" 
                        v-if="[0, 100].indexOf(scope.row.progress)<0">
                        <el-col :span="6">
                            <p style="line-height:22px">{{titleText}}</p> 
                        </el-col>
                        <el-col :span="18">
                        <!--progressNumList[currentIndex]-->
                            <el-progress 
                                :text-inside="true" 
                                :stroke-width="20" 
                                :percentage="scope.row.progress" 
                                :color="customColor">
                            </el-progress>
                            <el-link type="danger" icon="el-icon-loading">当前正在上传，请勿刷新页面</el-link>
                        </el-col>
                        
                    </el-row>
                    
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="110" fixed="right">
                <template slot-scope="scope">
                    <template v-if="scope.row.isqd==='1'">
                        <my-tag 
                            type="danger" 
                            v-if="scope.row.by5==='0'">
                            还没有全部解密成功，无法进行导入
                        </my-tag>
                        <template v-if="scope.row.by5!=='0'">
                            <el-button 
                                type="text" 
                                v-if="scope.row.by3!=='100.00'" 
                                icon="el-icon-collection" 
                                @click="send(scope.row,scope.$index)" 
                                :disabled="scope.row.progress!==0">
                                导入投标人清单
                            </el-button>
                            <el-link
                                v-if="model.isxyf"
                                :href="'/pingbiao/pbzb/lookcreditscore?bdcode='+scope.row.bdcode" 
                                target="_blank" 
                                :underline="false" 
                                type="primary" 
                                icon="el-icon-view">
                                查看信用分
                            </el-link>
                            <el-button 
                                type="text" 
                                icon="el-icon-s-open" 
                                v-if="scope.row.by3==='100.00'&&model.isyqb" 
                                @click="lookYqb(scope.row.bdcode)">
                                预清标
                            </el-button>
                        </template>
                    </template>
                    <template v-if="scope.row.isbim==='1'">
                        <el-button 
                            type="text" 
                            v-if="scope.row.bimimportstatus!=='100.00'" 
                            icon="el-icon-collection"
                            @click="sendBIM(scope.row,1,scope.$index)" 
                            :disabled="scope.row.progress!==0">
                            导入投标人BIM模型
                        </el-button>
                        <template v-if="scope.row.bimimportstatus==='100.00'&&scope.row.issxfbim==='1'">
                            <el-button 
                                type="text" 
                                v-if="scope.row.sxfbimimportstatus!=='100.00'" 
                                icon="el-icon-collection" 
                                @click="sendBIM(scope.row,2,scope.$index)" 
                                :disabled="scope.row.progress!==0">
                                导入二信封BIM模型
                            </el-button>
                        </template>
                    </template>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" :after-query="firstData" v-model="tableData" :search="pgData" :action="`${getGetters('mngUrl')}/pingbiao/pbzb/getlist.json`">
        </my-pagination>

    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

export default {
    mixins: [LIST_PAGE_MIXIN],
    data() {
        return{
            pgData:{
                procode:this.getQuery('procode'),
                sortname:'bdcode',
            },
            model:{},
            progressNumList:[],
            customColor: [
                {color: '#f56c6c', percentage: 20},
                {color: '#e6a23c', percentage: 40},
                {color: '#5cb87a', percentage: 60},
                {color: '#1989fa', percentage: 80},
                {color: '#6f7ad3', percentage: 100}
            ],
            titleText:'',
            websocket:null,
            currentBdcode:'',
            currentIndex:'',
        }
    },
    computed: {
        procode: function() {
            return this.getQuery('procode') || '';
        },
    },
    watch: {
    
    },
    methods: {
        firstData(data){
            var that = this
            data.forEach(function (item){
                item.progress = 0
            })
            that.tableData = data
        },
        // 预清单
        lookYqb(bdcode){
            this.$get(`${this.getGetters('mngUrl')}/pingbiao/pbzb/getyqburl`, {
                bdcode:bdcode
            }, (data, res) => {
                window.open(data)
            })
        },
        // 投标清单发送消息
        send(row,index){
            var that = this;
            that.currentBdcode = row.bdcode;
            that.titleText = '投标人清单';
            that.currentIndex = index;

            row.progressKey = 'by3';

            that.tableData[index].progress=1
            that.$set(that.tableData,index,that.tableData[index])
            var sendStr = {type:'QD',to:row.bdcode};
            that.websocket.send(JSON.stringify(sendStr));
           
        },
        // BIM导入  1是单信封  2是双信封
        sendBIM(row,type,index){
            var that = this
            that.currentBdcode = row.bdcode
            that.titleText = 'BIM清单'
            that.currentIndex = index
            if(type===1){
                row.progressKey = 'bimimportstatus'
            }else{
                row.progressKey = 'sxfbimimportstatus';
            }
            

            that.tableData[index].progress=1
            that.$set(that.tableData,index,that.tableData[index])
            var sendStr = {type:'BIM',to:row.bdcode,packagenum:type};
		    that.websocket.send(JSON.stringify(sendStr));
        },
        searchXyf(){
            window.open('http://hpb.hbidding.com/pingbiao/pbnode/dwquery.do')
        }
    },
    created() {
       
    },
    mounted() {
        var that = this
        that.$get(`${this.getGetters('mngUrl')}/pingbiao/pbzb/list.json`, {
            procode:that.procode
        }, (data, res) => {
            that.model = data
            // websocket
            var host = that.model.host

            //判断当前浏览器是否支持WebSocket
            if ('WebSocket' in window) {
                that.websocket = new WebSocket(host+that.model.procode);
            }
            else {
                alert('当前浏览器 Not support websocket')
            }
            //连接发生错误的回调方法
            that.websocket.onerror = function () {
                setMessageInnerHTML("WebSocket连接发生错误");
            };
        
            //连接成功建立的回调方法
           that. websocket.onopen = function () {
                setMessageInnerHTML("WebSocket连接成功");
            }
            //接收到消息的回调方法
            that.websocket.onmessage = function (event) {

                var json = JSON.parse(event.data);
                that.tableData.forEach(function(item){
                    if(item.bdcode==json.bdcode){
                        item.progress = json.speed
                    }
                })
                if(json.code=='200'){
                    if(''!==json.error){ //不是一个投标单位，所以在返回200时，可能其中有投标单位导入出错
                        ShowMsg(json.error,'error');
                    }
                    if('100' == json.speed){
                        var currintIndex = 0
                        that.tableData.forEach((item,index) => {
                            if(item.bdcode === json.bdcode){
                                currintIndex = index
                                item[item.progressKey] = '100.00'
                                that.$set(that.tableData,currintIndex,item)
                            }
                        })
                    }
                    
                }else{
                    ShowMsg(json.error,'error');
                }
              
            }
            //连接关闭的回调方法
            that.websocket.onclose = function () {
                setMessageInnerHTML("WebSocket连接关闭");
            }
        
            //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
            //如果业务需求改变，可以不关闭连接
            window.onbeforeunload = function () {
                closeWebSocket();
            }
        
            //将消息显示在网页上
            function setMessageInnerHTML(innerHTML) {
                //document.getElementById('message').innerHTML += innerHTML + '<br/>';
            }
        
            //关闭WebSocket连接
            function closeWebSocket() {
                that.websocket.close();
            }
        });

    }
}
</script>

<style scoped lang="scss">

</style>
